export var wrapper = 'rounded-10 flex flex-col items-center p-4 pb-6 justify-between mt-2 bg-uiBg';
export var content = 'w-full flex flex-row justify-start items-center';
//# sourceMappingURL=points-progress-card.styles.js.map